export class Uri {
    static getUri(name: string): string {
        var uri = window.__URI[name];
        if (!uri) {
            throw `Could not find uri for ${name}`;
        }
        return uri;
    }
}


// WEBPACK FOOTER //
// ./www/js/Core/Helpers/Uri.ts